import { cssVar, mediaQuery } from 'src/app/styles/helper';
import { SpacingPropKeys } from 'src/app/styles/spacing';
import styled, { css } from 'styled-components';

export const MegaMenuWrapper = styled.div`
  position: absolute;
  z-index: 2;
  left: 0;
  top: 100%; //relative to #header
  width: 100%;

  ${mediaQuery(
    'lg',
    css`
      display: none;
    `
  )}
`;

export const MegaMenuExitZone = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100vh;
`;

interface FeaturesMegaMenuContainerProps {
  $isOpen: boolean;
  $maxHeight: number;
}

export const MegaMenuContainer = styled.div<FeaturesMegaMenuContainerProps>`
  z-index: 11;
  position: relative;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  max-height: ${({ $isOpen, $maxHeight }) => ($isOpen ? $maxHeight : 0)}px;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  background: ${cssVar('bg-primary')};
  box-shadow:
    0px 12px 16px -4px rgba(10, 13, 18, 0.08),
    0px 4px 6px -2px rgba(10, 13, 18, 0.03),
    0px 2px 2px -1px rgba(10, 13, 18, 0.04);
`;

interface MegaMenuChildContainerProps {
  $padding?: SpacingPropKeys;
}

export const MegaMenuChildContainer = styled.div<MegaMenuChildContainerProps>`
  display: block;
  padding: ${({ $padding }) => cssVar($padding)} 0px;
`;
